import {Component} from '@angular/core';
/**
 * \@title Stacked chips
 */
export class ChipsStackedExample {
  color: string;

  availableColors = [
    { name: 'none', color: '' },
    { name: 'Primary', color: 'primary' },
    { name: 'Accent', color: 'accent' },
    { name: 'Warn', color: 'warn' }
  ];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'chips-stacked-example',
  templateUrl: 'chips-stacked-example.html',
  styleUrls: ['chips-stacked-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ChipsStackedExample_tsickle_Closure_declarations() {
/** @type {?} */
ChipsStackedExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ChipsStackedExample.ctorParameters;
/** @type {?} */
ChipsStackedExample.prototype.color;
/** @type {?} */
ChipsStackedExample.prototype.availableColors;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
